export const footerMenuOptions = [
  {
    title: "title_1",
    subItens: [
      {
        label: "label_1",
        url: "who-we-are",
      },
      {
        label: "label_2",
        url: "why-choose-us",
      },
    ],
  },
  {
    title: "title_2",
    subItens: [
      {
        label: "label_3",
        url: "options-market",
      },
      {
        label: "label_4",
        url: "cripto-market",
      },
    ],
  },
  // {
  //   title: "title_3",
  //   subItens: [
  //     {
  //       label: "label_5",
  //       url: "help-center",
  //     },
  //     {
  //       label: "label_6",
  //       url: "send-request",
  //     },
  //   ],
  // },
  {
    title: "title_4",
    subItens: [
      {
        label: "label_7",
        url: "learn",
      },
      {
        label: "label_8",
        url: "community",
      },
    ],
  },
];
